
import {
    ApiManager,
    sessionService,
    SessionManager,
    LoggerUtility,
    EnumUtility,
    UtilityLibrary
} from '../components/ComponentsLibrary';

class WorkflowDataService1 {
    constructor() {
        this.caseUniqueID = "caseNumber";
    }

    async getWorkflowActivityFromApiByCaseID(paramsObj) {
        try {
            const workflowActivityApiData = await ApiManager.GetWorkflowActivityList(paramsObj);
            if (workflowActivityApiData && workflowActivityApiData.length > 0) {                
                return workflowActivityApiData;
            }
            else {
                return null;
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getWorkflowActivityFromApiByCaseID", {});
        }

    };

}


class WorkflowDataService {
    constructor() {
        this.caseUniqueID = "caseNumber";
    }

    async getWorkflowActivityFromApiByCaseID(paramsObj, requestFor = "workflowActivities") {
        try {
            let apiData;
            if (requestFor === 'workflowActivities'){
                apiData= await ApiManager.GetWorkflowActivityList(paramsObj);
            }
            else{
                apiData = await ApiManager.GetActiveWorkflowFinancialWorkList(paramsObj);
            }
            if (apiData && apiData.length > 0) {                
                return apiData;
            }
            else {
                return null;
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getWorkflowActivityFromApiByCaseID", {});
        }

    };

    async getNoCaseWorkflowActivityFromApi(paramsObj, requestFor = "workflowActivities") {
        try {
            let apiData;  
            if (requestFor === 'workflowActivities'){
                apiData= await ApiManager.GetNoCaseWorkflowActivityList(paramsObj);
            }
            else{
                apiData = await ApiManager.GetActiveWorkflowNoCaseFinancialWorkList(paramsObj);
            }
            if (apiData && apiData.length > 0) {                
                return apiData;
            }
            else {
                return null;
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getNoCaseWorkflowActivityFromApi", {});
        }

    };

    async getWorkflowStatusOptions(paramsObj) {
        try {
            const apiData = await ApiManager.GetAllDropdownTypes(paramsObj);
            if (apiData && apiData.length > 0) {
                return apiData;
            }
            else {
                return [];
            }  
        }
        catch (error){
            throw LoggerUtility.ProcessErrorData(error, "getWorkflowTypes", {});
        }
        
    }

}


const workflowDataService = new WorkflowDataService();

export default workflowDataService;